export default {
    PACIENTE: 1,
    ACOMPANHANTE: 2,
}